import type { DateValue } from 'reka-ui';
import { DateTime } from 'luxon';

export const getMonthKey = (date: DateValue): string =>
  DateTime.fromObject({ year: date.year, month: date.month }).toFormat('yyyy-M');

const getMonthDistance = (firstMonth: DateValue, targetMonth: DateValue): number => {
  const start = DateTime.fromObject({ year: firstMonth.year, month: firstMonth.month }).startOf('month');
  const end = DateTime.fromObject({ year: targetMonth.year, month: targetMonth.month }).startOf('month');
  return end.diff(start, 'months').months;
};

export const getVisibleMonthCount = (firstMonth: DateValue, targetMonth: DateValue): number =>
  Math.max(12, getMonthDistance(firstMonth, targetMonth) + 12);

export const getMonthCountUpTo = (from: DateValue, to: DateValue): number => getMonthDistance(from, to) + 1;
